import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeftRight, Frame, Heart, LayoutGrid, Palette, Sparkles, Sticker, Ticket } from 'lucide-react';
import { useDesktopLayout } from '../../components/DesktopLayout/DesktopNavigation';
import { useTheme } from '../../contexts/ThemeContext';
import { useLanguage } from '../../contexts/LanguageContext';
import './StoreRefresh.css';

const sections = [
  ['/store', 'اكتشف', 'Discover', LayoutGrid],
  ['/store?section=potions', 'الأدوات', 'Tools', Ticket],
  ['/frames-store', 'الإطارات', 'Frames', Frame],
  ['/reaction-store', 'التفاعلات', 'Reactions', Heart],
  ['/sticker-store', 'الملصقات', 'Stickers', Sticker],
  ['/bubble-store', 'الفقاعات', 'Bubbles', Sparkles],
  ['/profile-theme-store', 'الثيمات', 'Themes', Palette],
  ['/store?section=conversion', 'العملات', 'Currencies', ArrowLeftRight],
];

export default function StoreWorkspace({ children }) {
  const { theme } = useTheme(), { language } = useLanguage(), location = useLocation();
  const desktop = useDesktopLayout(), ar = language === 'ar';
  const section = new URLSearchParams(location.search).get('section');
  const current = location.pathname === '/store' && section ? `/store?section=${section}` : location.pathname;
  const content = <><nav className="store-departments" aria-label={ar ? 'أقسام المتجر' : 'Store departments'}>{sections.map(([path, arabic, english, Icon]) => <Link to={path} key={path} aria-current={current === path ? 'page' : undefined}><Icon size={18}/><span>{ar ? arabic : english}</span></Link>)}</nav><div className="store-content">{children}</div></>;
  // DesktopRouteLayout owns the shared sidebar and page heading for every store route.
  return <div className={`${desktop ? 'store-workspace' : 'store-mobile'} store-refresh ${theme === 'dark' ? 'dark' : ''}`} dir={ar ? 'rtl' : 'ltr'}>{content}</div>;
}
